/* eslint-disable no-console */
import Axios from 'axios'

export const getUsignData = async (url, cbSetData, hookName = 'captura') => {
    try {
        const { data } = await Axios.get(url)
        if (
            data.message === 'OK' &&
            data.resultsWebhookSteps &&
            data.resultsWebhookSteps[hookName]
        ) {
            cbSetData(data.resultsWebhookSteps[hookName])
            return
        }

        const errorMsg = `Error getting data: ${data.message}`
        console.log(errorMsg)
    } catch (e) {
        const errorMsg = e.name
        console.log(errorMsg)
    }

    cbSetData([])
}

export default getUsignData
